/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 18:02:38
 * @LastEditTime: 2022-01-29 18:44:10
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 惠市宝对账单汇总列表
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/HSBList/index.jsx
 */
import React, { useRef } from 'react'
import TableHelper from '../../../components/TableHelper'
import {
    fetchPlatformRecordWftPayOrderSummaryList
} from '../../../services/platformAccountingRecord'
import { formatTime } from '../../../utils'
import HSBInfoList from './components/WFTInfoList'
const HSBList = (props) => {
    let HSBInfoListRef = useRef()
    const columns = [
        { title: '交易日期', dataIndex: 'tradeDate', render: (text) => formatTime(text, 'YYYY-MM-DD') },
        { title: '交易笔数', dataIndex: 'tradeNum' },
        { title: '交易金额', dataIndex: 'tradeAmountSum' },
        { title: '手续费', dataIndex: 'serviceChargeSum' },
        { title: '交易净额', dataIndex: 'settlementAmountSum' },
        { title: '操作', dataIndex: 'action', render: (text, record) => {
            return (
                <a onClick={() =>HSBInfoListRef.open(formatTime(record.tradeDate, 'YYYY-MM-DD'))}>详情</a>
            )
        }}
    ]

    const searchOptions = [
        { key: 'startDate', type: 'date', placeholder: '开始日期' },
        { key: 'endDate', type: 'date', placeholder: '结束日期' },
    ]
    return (
        <div>
            <TableHelper columns={columns} searchOptions={searchOptions} request={fetchPlatformRecordWftPayOrderSummaryList} />
            <HSBInfoList getRef={ref => HSBInfoListRef = ref} />
        </div>
    )
}

export default HSBList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/WFTList/index.jsx